
import { fn } from '../utils';
import ToDictionary = fn.ToDictionary;

import { IPageProperty } from '../nav/navtypes';
import { NavPropertyItems } from './navpropertyitems';
import { NavPageItem } from './navpageitem';
import { NavPropertyItem } from './navpropertyitem';
import { Model, IObservableArray } from './navmodel';

/** Information about Current Line Items State fo an array Typed Property  */
export class NavLineData extends NavPropertyItems {

    /** All Line Items Access (as implicitly Change Aware Observable Array,
     * building an Observable Array from NavPropertyItem will fail (kendo wrap logic!)) */
    public readonly ModelItems: IObservableArray<Model>;

    constructor(public readonly Root: NavPageItem, public readonly Property: IPageProperty) {
        super(Root.Service, Property.ArrayProperties);
        this.Anchor = Root.Anchor;
        // Enforced to be an Observable Array by out Logic!
        this.ModelItems = Root.GetValue(Property.Name, true);
    }

    /** Delete Items by ids (Enqueued, one after the other) */
    public DeleteItems(ids: string[]) {
        var items = this.GetItems(ids);
        var result = this.Anchor.EnqueueOperation(() => items.reduce((prev, curr) => prev.then(() => this.Root.DeleteRowItem(curr, this)).then(fn.noop), this.Service.$c.when()));

        return result.then((r) => {
            // Ensure Valid Selection after Delete
            if (this.SelectionCount == 0 && this.Count > 0)
                this.SetSelected(this.Items[0]);
            return r;
        });
    }

    /** Duplicate Items by Ids (Enqueued, one after the other), return Array of  newly Created Items */
    public DuplicateItems(ids: string[]) {
        const items = this.GetItems(ids);
        var clientIds = ToDictionary(this.Items, "ClientKey");
        var root = this.Root;
        var result = root.Anchor.EnqueueOperation(() => items.reduce((prev, curr) => prev.then(() => root.DuplicateRowItem(curr, this)).then(fn.noop), root.Service.$c.when()));
        return result.then(() => this.Items.filter(item => !clientIds[item.ClientKey]));
    }

    /** Insert New Item via MetaData - Configured Functionality/Method */
    public InsertNewItem() { return this.Root.InsertNewRowItem(this.Property); }

    /** All Nav Property Items Access */
    public readonly Items: NavPropertyItem[] = [];
}
